import service, { unwrapResponse } from '@/utils/request'

// 登录
export const login = ({ userName, username, password, corpid }) => {
    const loginName = (userName || username || '').trim()

    const data = {
        username: loginName,
        password,
        corpid
    }

    return service.request({
        url: 'xuper_api/loginValid',
        data: data,
        method: 'post'
    })
}

// 获取用户菜单
export const getUserMenu = (url) => {
    return service.request({
        url: url,
        method: 'post'
    })
}

// 登出
export const logout = () => {
    return service.request({
        url: 'logout',
        method: 'post'
    })
}

// 获取加密密码
export const getEncodePwd = (password) => {
    return service.request({
        url: 'xuper_api/encodePwd',
        method: 'post',
        data: {
            password
        }
    })
}

/**
 * 获取表字段或数据。
 * 新签名：url, table, key, value, key2, value2, key3, value3, cond
 * 兼容旧签名：url, username, password, table, key, value, key2, value2, key3, value3, cond
 */
export const getTabColOrData = (...args) => {
    let url_, table_, key_, val_, key2_, val2_, key3_, val3_, cond_

    if (args.length >= 11) {
        [url_, , , table_, key_, val_, key2_, val2_, key3_, val3_, cond_] = args
    } else {
        [url_, table_, key_, val_, key2_, val2_, key3_, val3_, cond_] = args
    }

    return service(url_, {
        method: 'post',
        data: {
            p_key: key_,
            p_value: val_,
            p_key2: key2_,
            p_value2: val2_,
            p_key3: key3_,
            p_value3: val3_,
            p_table: table_,
            p_cond: cond_
        }
    })
}

// 获取表格字段
export const getTab_Column = (
    ...args
) => {
    let v_url, table_, key_, val_, key2_, val2_, cond_, v_lang
    if (args.length >= 9) {
        [v_url, , , table_, key_, val_, key2_, val2_, cond_, v_lang] = args
    } else {
        [v_url, table_, key_, val_, key2_, val2_, cond_, v_lang] = args
    }

    return service(v_url, {
        method: 'post',
        data: {
            p_key: key_,
            p_value: val_,
            p_key2: key2_,
            p_value2: val2_,
            p_table: table_,
            p_cond: cond_
        }
    }).then(res => {
        const body = unwrapResponse(res) || {}
        const v_data = body.result || []

        const v_column = v_data.map(item => ({
            title: v_lang === 'EN' ? item.FLDEN : v_lang === 'YN' ? item.FLDYN : item.title,
            key: item.key,
            align: item.align,
            width: item.width,
            edcss: item.EDCSS,
            thide: item.THIDE,
            fhide: item.FHIDE,
            disabled: item.DISABLED,
            sortable: item.SORTABLE,
            notnull: item.NOTNULL
        }))

        return v_column
    })
}

// 获取基础数据
export const getBaseData = (
    v_url,
    v_key,
    v_value,
    v_key2,
    v_value2,
    v_table,
    v_cond
) => {
    return service(v_url, {
        method: 'post',
        data: {
            p_key: v_key,
            p_value: v_value,
            p_key2: v_key2,
            p_value2: v_value2,
            p_table: v_table,
            p_cond: v_cond
        }
    })
}

// JSON key 转大写
export const upperJSONKey = (json) => {
    if (json instanceof Array) {
        for (var key in json) {
            upperJSONKey(json[key])
        }
    } else if (json instanceof Object) {
        for (var key2 in json) {
            var reg = /[a-z0-9]+$/

            if (json[key2] instanceof Object || json[key2] instanceof Array) {
                upperJSONKey(json[key2])
            } else {
                if (reg.test(key2)) {
                    var lowerKey = key2.toUpperCase()
                    json[lowerKey] = json[key2]
                    delete json[key2]
                }
            }
        }
    }

    return json
}

// JSON key 转小写
export const lowerJSONKey = (json) => {
    if (json instanceof Array) {
        for (var key in json) {
            lowerJSONKey(json[key])
        }
    } else if (json instanceof Object) {
        for (var key2 in json) {
            var reg = /[A-Z0-9]+$/

            if (json[key2] instanceof Object || json[key2] instanceof Array) {
                lowerJSONKey(json[key2])
            } else {
                if (reg.test(key2)) {
                    var lowerKey = key2.toLowerCase()
                    json[lowerKey] = json[key2]
                    delete json[key2]
                }
            }
        }
    }

    return json
}

// 判空
export const isNull = (v_obj) => {
    if (v_obj == null || !v_obj) {
        return ''
    } else {
        return v_obj
    }
}
